<template>
    <div class="ssv-page-content__main ssv-thankyou-page--text">
        <main class="ssv-page-content__in ssv-page-content__in--thankyou-page">
            <h1>Děkujeme za objednávku</h1>
            <div  v-if="type.code === 500">
                <p>Veškeré informace k provedení platby obdržíte na vámi uvedený e-mail.</p>
            </div>
            <div v-if="!trainingCenter && type.code !== 500">
                <p>
                    Vaše objednávka dárkového poukazu proběhla úspěšně. Na Váš e-mail vám brzy dorazí výzva k
                    platbě. Po zaplacení Vám zašleme vygenerovaný dárkový poukaz na e-mail uvedený v objednávce.
                    Pokud máte jakýkoli dotaz, napište nám na <a href="mailto:skolasuchevystavby@saint-gobain.com" rel="nofollow" title="Napište nám">skolasuchevystavby@saint-gobain.com</a>
                </p>
            </div>
            <div v-if="trainingCenter && type.code !== 500">
                <p v-if="trainingCenter.accredited === false && trainingCenter.organizer === false">
                    Vaše objednávka proběhla úspěšně. Na Váš e-mail vám brzy dorazí výzva k platbě a následně
                    bližší informace ke kurzu.
                    Pokud máte jakýkoli dotaz týkající se kurzu, napište nám na
                    <a :href="'mailto:' + trainingCenter.email">{{trainingCenter.email}}</a>
                </p>
                <p v-if="trainingCenter.accredited">
                    Vaše objednávka proběhla úspěšně. Na Váš e-mail vám brzy dorazí bližší informace ke školení.<br/>
                    Pokud máte jakýkoli dotaz týkající se školení, napište nám na adresu
                    <a :href="'mailto:' + trainingCenter.email">{{trainingCenter.email}}</a>
                </p>
                <p v-if="trainingCenter.organizer">
                    Vaše objednávka proběhla úspěšně. Na Váš e-mail vám brzy dorazí výzva k platbě a následně
                    bližší informace ke kurzu.
                    Pokud máte jakýkoli dotaz týkající se kurzu, napište nám na
                    <a :href="'mailto:' + trainingCenter.email">{{trainingCenter.email}}</a>
                </p>
            </div>
        </main>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'SsvOrderThankContainer',
        computed: {
            ...mapGetters('ssvOrder', ['trainingCenter', 'type'])
        },
        mounted() {
            window.scrollTo(0, 0);
            const videoBlock = document.getElementById('videos-block');
            if (videoBlock) {
                videoBlock.style.display = 'block';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/ThankContainer.vue